(function(algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Haun tulokset',
    search: 'Nykyinen haku',
    noCollectionFound: 'Kokoelmia ei löytynyt',
    allProducts: 'Näytä kaikki tuotteet',
    matching: 'osumat',
    sortBy: 'Järjestys',
    relevance: 'Osuvuus',
    outOf: 'out of',
    resultsFound: 'tulosta löytyi',
    oneResultFound: '1 tulos löytyi',
    noResultFound: 'Ei tuloksia',
    addToCart: 'Lisää koriin',
    searchForProduct: 'Etsi tuotteita',
    selectedFilter: 'Valitut suodattimet',
    clearAll: 'Tyhjennä',
    noPageFound: 'Sivua ei löytynyt',
    outOfStock: 'Ei varastossa',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'No result for query ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return '- ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
